import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { cn } from './ui/utils'

interface AccordionItemProps {
  value: string
  trigger: string
  content: string
  isOpen: boolean
  onToggle: () => void
  className?: string
}

function AccordionItem({
  trigger,
  content,
  isOpen,
  onToggle,
  className,
}: AccordionItemProps) {
  return (
    <div className={cn('border border-border rounded-lg overflow-hidden', className)}>
      {/* Trigger */}
      <button
        onClick={onToggle}
        className="w-full flex items-start justify-between gap-4 p-6 text-left hover:bg-accent/50 transition-colors"
      >
        <span className="flex-1">{trigger}</span>
        <ChevronDown
          className={cn(
            'w-5 h-5 shrink-0 text-muted-foreground transition-transform duration-200',
            isOpen && 'rotate-180'
          )}
        />
      </button>

      {/* Content */}
      <div
        className={cn(
          'grid transition-all duration-200 ease-in-out',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        )}
      >
        <div className="overflow-hidden">
          <div className="px-6 pt-4 pb-6 text-muted-foreground leading-relaxed">
            {content}
          </div>
        </div>
      </div>
    </div>
  )
}

interface SimpleAccordionProps {
  items: Array<{
    value: string
    trigger: string
    content: string
    className?: string
  }>
}

export function SimpleAccordion({ items }: SimpleAccordionProps) {
  const [openItem, setOpenItem] = useState<string | null>(null)

  return (
    <div className="space-y-4">
      {items.map((item) => (
        <AccordionItem
          key={item.value}
          value={item.value}
          trigger={item.trigger}
          content={item.content}
          isOpen={openItem === item.value}
          onToggle={() =>
            setOpenItem(openItem === item.value ? null : item.value)
          }
          className={item.className}
        />
      ))}
    </div>
  )
}

